// Le code dans ce fichier se chargera sur chaque page de votre site

$w.onReady(() => {
	// Write your code here

});